'use client';
import cn from 'classnames';

import './LoadingSpinner.style.scss';

type LoadingSpinnerProps = {
  className?: string;
  size?: number;
  gradient?: string;
  children?: React.ReactNode;
};

function LoadingSpinner(props: LoadingSpinnerProps) {
  const { className = '', size = 24, gradient, children } = props;

  if (gradient) {
    return (
      <div className={cn('LoadingSpinner', 'with-gradient', className)}>
        <svg
          className='spinner-svg'
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
        >
          <style>
            {`.spinner-svg{transform-origin:center;animation:spinner_KYSC .75s infinite linear}@keyframes spinner_KYSC{100%{transform:rotate(360deg)}}`}
          </style>
          <g
            clipPath='url(#paint0_angular_2_120_clip_path)'
            data-figma-skip-parse='true'
          >
            <g transform='matrix(0.0115911 -0.00310583 0.00310583 0.0115911 12.0011 12)'>
              <foreignObject
                x='-1083.33'
                y='-1083.33'
                width='2166.67'
                height='2166.67'
              >
                <div
                  style={{
                    background: `conic-gradient(${gradient})`,
                    height: '100%',
                    width: '100%',
                    opacity: 1
                  }}
                />
              </foreignObject>
            </g>
          </g>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.107 23.5911C21.5086 21.8758 25.3075 15.2958 23.5922 8.8942C21.8769 2.49261 15.2969 -1.30638 8.89531 0.408923C2.49372 2.12422 -1.30527 8.70427 0.410028 15.1059C2.12533 21.5075 8.70537 25.3064 15.107 23.5911ZM14.5893 21.6593C19.924 20.2299 23.0898 14.7465 21.6604 9.41184C20.231 4.07718 14.7476 0.911357 9.41295 2.34077C4.07829 3.77019 0.912461 9.25356 2.34188 14.5882C3.7713 19.9229 9.25467 23.0887 14.5893 21.6593Z'
          />
          <defs>
            <clipPath id='paint0_angular_2_120_clip_path'>
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.107 23.5911C21.5086 21.8758 25.3075 15.2958 23.5922 8.8942C21.8769 2.49261 15.2969 -1.30638 8.89531 0.408923C2.49372 2.12422 -1.30527 8.70427 0.410028 15.1059C2.12533 21.5075 8.70537 25.3064 15.107 23.5911ZM14.5893 21.6593C19.924 20.2299 23.0898 14.7465 21.6604 9.41184C20.231 4.07718 14.7476 0.911357 9.41295 2.34077C4.07829 3.77019 0.912461 9.25356 2.34188 14.5882C3.7713 19.9229 9.25467 23.0887 14.5893 21.6593Z'
              />
            </clipPath>
          </defs>
        </svg>
        {children && <div className='spinner-content'>{children}</div>}
      </div>
    );
  }
  return (
    <svg
      className={cn(
        'LoadingSpinner',
        'LoadingSpinner-svg',
        'spinner_aj0A',
        className
      )}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <style>
        {`.spinner_aj0A{transform-origin:center;animation:spinner_KYSC .75s infinite linear}@keyframes spinner_KYSC{100%{transform:rotate(360deg)}}`}
      </style>
      <path d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z' />
    </svg>
  );
}

export default LoadingSpinner;
